import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/geo/state.js'
import actions from '@/store/modules/geo/actions.js'
import mutations from '@/store/modules/geo/mutations.js'
import getters from '@/store/modules/geo/getters.js'

export default {
  state: cloneDeep(state),
  actions,
  mutations,
  getters,
}
